import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
//primeReact
import { Button } from "primereact/button";
//components
import Input from "../../../../../../components/input/Input";
import CalendarInput from "../../../../../../components/input/CalendarInput";
//imports
import Modal from "../../../../../../components/modal/Modal";
import { searchInfoConvertedValue } from "../../../../../../services/Parcel/searchInfoConvertedValue";
import { anticipate } from "../../../../../../utils/anticipate";
import { formatCurrency } from "../../../../../../utils/formatCurrency";

import NumberInput from "../../../../../../components/input/NumberInput";
import { Skeleton } from "primereact/skeleton";
import { price } from "../../../../../../utils/price";
import { cleanFormattingValue } from "../../../../../../utils/cleanFormattingValue";
import { sendRenegotiateParcels } from "../../../../../../services/Parcel/sendRenegotiateParcels";
import { useParcelContext } from "./ParcelContext";

const ModalRenegotiateInstallments = () => {
  const {
    control,
    handleSubmit: handleUpdateParcel,
    errors,
    setValue,
    getValues,
    reset
  } = useForm();
  // eslint-disable-next-line no-unused-vars
  const [isVisibleConfirm, setIsVisibleConfirm] = useState(false);
  const [isCalculateClicked, setIsCalculateClicked] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  // eslint-disable-next-line no-unused-vars

  // eslint-disable-next-line no-unused-vars
  const [showAnticipateValueColumn, setShowAnticipateValueColumn] =
    useState(false);

  const {
    idSale,
    itemsSelected,
    setItemsSelected,
    setSelectAll,
    isModalVisibleRenegotiate,
    setIsModalVisibleRenegotiate,
    isModalVisibleCalculate,
    setIsModalVisibleCalculate,
    refetch,
  } = useParcelContext();

  const style = {
    width: window.innerWidth <= 992 ? "95vw" : "95vw",
  };

  const simplifiedParcels = itemsSelected.map((parcel) => ({
    ...parcel,
    description:
      parcel.description && parcel.description.name
        ? parcel.description.name
        : parcel.description,
  }));

  function sendUpdate(data) {

    if (cleanFormattingValue(data.installments_value) <= 0) {
      return toast.warning("O valor da Parcela de Financiamento deve ser maior que R$ 0,00.")
    }
    //    console.log(data)
    setLoading(true);
    const installments = simplifiedParcels.map((parcel) => parcel.id);
    const result = {
      value: cleanFormattingValue(data.balance_renegotiate),
      value_installments: cleanFormattingValue(data.installments_value),
      discount: data.discount,
      entry: data.entry_value,
      interest_rate: data.interest_rate,
      tariffs_fee: data.renegotiation_fees,
      how_many_installments: data.number_installments,
      date_first_installment: data.installments_date?.toISOString()?.split("T")[0],
      date_entry: data?.entry_date?.toISOString()?.split("T")[0],
      date_contract: data.renegotiate_date?.toISOString()?.split("T")[0],
      installment_description_id: 0,
      installments_id: installments,
    };

    const loadingNotification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );

    //Executar Antecipação das Parcelas
    sendRenegotiateParcels(result)
      .then((result) => {
        // Verificar se a antecipação foi bem-sucedida
        if (result.success) {
          // Exibir notificação de sucesso
          // toast.update(loadingNotification, {
          //   render:
          //     "Parcelas renegociadas com sucesso! Aguarde as parcelas estão sendo atualizadas...",
          //   position: "top-right",
          //   autoClose: 5000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          //   theme: "colored",
          //   type: "success",
          //   isLoading: false,
          // });
          refetch().then(() => {
            // Após a atualização, exibir notificação de sucesso
            toast.update(loadingNotification, {
              render: "Renegociação em Análise!",
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              type: "info",
              isLoading: false,
            });
          });
        } else {
          // Se houver um erro durante a antecipação de parcelas,
          // exibir uma notificação de erro
          toast.update(loadingNotification, {
            render: result.error,
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "error",
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        // Se houver um erro durante a antecipação de parcelas,
        // exibir uma notificação de erro genérica e logar o erro no console.
        toast.update(loadingNotification, {
          render: "Não foi possível renegociar as parcelas!",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
        console.error("Erro ao antecipar parcelas:", error);
      });
    setItemsSelected([]);
    setSelectAll([]);
    setIsModalVisibleRenegotiate(false)

  }

  function sendUpdateInstallmentValue() {
    let data;
    const getDiscount = getValues("discount");
    const getBalance_renegotiate = getValues("balance_renegotiate");
    const getInterest_rate = getValues("interest_rate");
    const getNumber_installments = getValues("number_installments");
    const getRenegotiation_fees = getValues("renegotiation_fees");
    const getEntry_value = getValues("entry_value");
    data = {
      discount: getDiscount,
      balance_renegotiate: getBalance_renegotiate,
      interest_rate: getInterest_rate,
      number_installments: getNumber_installments,
      renegotiation_fees: getRenegotiation_fees,
      entry_value: getEntry_value
    }


    setIsCalculateClicked(true);
    setLoading(true);

    setIsCalculateClicked(true);
    const balanceDueValue = data.balance_renegotiate
      ? cleanFormattingValue(data.balance_renegotiate)
      : 0;
    const interestRate = data.interest_rate
      ? parseFloat(data.interest_rate)
      : 0;
    const numberInstallments = data.number_installments
      ? parseInt(data.number_installments)
      : 0;

    const discount = data.discount || 0;
    const renegotiationFees = data.renegotiation_fees || 0;
    const entryValue = data.entry_value || 0;
    const saldoRenegociar =
      balanceDueValue - discount + renegotiationFees - entryValue;
    const saldoTotal =
      balanceDueValue - discount + renegotiationFees - entryValue;

    if (saldoTotal > 0) {
      setValue("balance_due", formatCurrency(saldoRenegociar));
    } else {
      setValue("balance_due", formatCurrency(0));
    }

    const result = price(saldoRenegociar, interestRate, numberInstallments) > 0 ? price(saldoRenegociar, interestRate, numberInstallments) : 0;

    setValue("installments_value", formatCurrency(result));
    setIsVisibleConfirm(true);
    setIsCalculateClicked(false);
  }

  useEffect(() => {
    const searchBalanceDue = async () => {
      // eslint-disable-next-line no-unused-vars
      let teste = simplifiedParcels;
      setIsCalculateClicked(true);
      const installments = simplifiedParcels.map((parcel) => parcel.id);

      const result = {
        sale_id: idSale,
        action: "renegotiate",
        installments: installments,
      };
      // eslint-disable-next-line no-unused-vars
      let totalParcelValue = 0;

      searchInfoConvertedValue(result)
        .then((dado) => {
          // eslint-disable-next-line no-unused-vars
          let teste = { ...dado }; // Criando uma cópia do objeto 'dado'
          let totalParcelValue = 0;
          for (const key in dado) {
            if (
              Object.hasOwnProperty.call(dado, key) &&
              !isNaN(parseInt(key))
            ) {
              const parcel = dado[key];
              const processedParcel = {
                ...parcel,
                amortization_system: dado["amortization_system"],
                total_installments: dado["total_installments"],
                number_financing_installments:
                  dado["number_financing_installments"],
                financing_value: dado["financing_value"],
                date_first_installment: dado["date_first_installment"],
                idSale: idSale,
                payment_date: new Date().toISOString().split("T")[0],
                change_month_anticipation: dado["change_month_anticipation"],
                late_fee: dado["late_fee"],
                late_interest: dado["late_interest"],
              };
              console.log(processedParcel);
              const newResult = anticipate(processedParcel);
              totalParcelValue += newResult;
            }
          }

          setValue("balance_renegotiate", formatCurrency(totalParcelValue));
        })
        .then(() => {
          setLoadingModal(false);
        });
    };
    if (isModalVisibleCalculate === true) {
      searchBalanceDue().then(() => {
        setIsVisibleConfirm(true);
        setIsCalculateClicked(false);
        setShowAnticipateValueColumn(true);
        setLoading(false);
        setLoadingModal(true);
        setIsModalVisibleCalculate(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalVisibleCalculate]);

  return (
    <>
      <Modal
        dynamicTitle="Renegociar Parcelas Selecionadas"
        id="modal_cad"
        onHide={() => {
          reset();
          setIsModalVisibleRenegotiate(!isModalVisibleRenegotiate);
          setItemsSelected([]);
          setSelectAll([]);
          setShowAnticipateValueColumn(false);
        }}
        visible={isModalVisibleRenegotiate}
        style={style}
      >
        <form onSubmit={handleUpdateParcel(sendUpdate)}>
          {loadingModal ? (
            <div className="row mt-2">
              <div className="row">
                <div className="col-md-6 my-4">
                  <Skeleton width="100%" height="50px"></Skeleton>
                </div>
                <div className="col-md-6 my-4">
                  <Skeleton width="100%" height="50px"></Skeleton>
                </div>
                <div className="col-md-6 my-4">
                  <Skeleton width="100%" height="50px"></Skeleton>
                </div>
                <div className="col-md-6 my-4">
                  <Skeleton width="100%" height="50px"></Skeleton>
                </div>
              </div>
              <div className="row pt-3">
                <div className="col-6 text-start"></div>
                <div className="col-6 d-flex justify-content-end">
                  <Skeleton width="20%" height="50px"></Skeleton>
                </div>
              </div>
            </div>
          ) : (
            <div className="mb-2">
              {/* SALDO DEVEDOR */}
              <div className="row">
                <div className="col-md-6">
                  <Input

                    className="p-inputtext-sm rounded-4"
                    disabled={true}
                    disable={true}
                    suffix={""}
                    prefix={"R$"}
                    placeholder={"0"}
                    max={undefined}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    name={`balance_renegotiate`}
                    control={control}
                    label="Saldo à Renegociar"
                    style={{ fontWeight: "bold" }}
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    className="p-inputtext-sm rounded-4"
                    disabled={true}
                    disable={true}
                    suffix={""}
                    prefix={"R$"}
                    placeholder={"0"}
                    max={undefined}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    name={`balance_due`}
                    control={control}
                    label="Saldo à Financiar"
                    style={{ fontWeight: "bold" }}
                  />
                </div>
              </div>

              {/* DESCONTO - TAXAS */}
              <div className="row">
                <div className="col-md-6">
                  <NumberInput
                    className="p-inputtext-sm rounded-4"
                    suffix={""}
                    mode="currency"
                    currency="BRL"
                    locale="pt-BR"
                    useGrouping={true}
                    placeholder={"0"}
                    onChange={sendUpdateInstallmentValue}
                    max={undefined}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    name={`discount`}
                    control={control}
                    label="Desconto Concedido"
                    style={{ fontWeight: "bold" }}
                  />
                </div>

                <div className="col-md-6">
                  <NumberInput
                    className="p-inputtext-sm rounded-4"
                    suffix={""}
                    mode="currency"
                    currency="BRL"
                    locale="pt-BR"
                    useGrouping={true}
                    placeholder={"0"}
                    onChange={sendUpdateInstallmentValue}
                    max={undefined}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    name={`renegotiation_fees`}
                    control={control}
                    label="Tarifas / Taxa de Renegociação"
                    style={{ fontWeight: "bold" }}
                  />
                </div>
              </div>

              {/* ENTRADA */}
              <div className="row">
                <div className="col-md-6">
                  <NumberInput
                    required={true}
                    className="p-inputtext-sm rounded-4"
                    suffix={""}
                    mode="currency"
                    currency="BRL"
                    locale="pt-BR"
                    useGrouping={true}
                    onChange={sendUpdateInstallmentValue}
                    placeholder={"0"}
                    max={undefined}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    name={`entry_value`}
                    control={control}
                    label="Valor de Entrada"
                    style={{ fontWeight: "bold" }}
                  />
                </div>

                <div className="col-md-6">
                  <CalendarInput
                    type="textarea"
                    isRequired={true}
                    className="p-inputtext-sm rounded-4"
                    label="Data de Entrada"
                    errors={errors}
                    control={control}
                    name="entry_date"
                    rows={4}
                    cols={30}
                  />
                </div>
              </div>

              {/* TAXA DE JUROS / QUANTIDADE DE PARCELAS */}
              <div className="row">
                <div className="col-md-6">
                  <NumberInput
                    required={true}
                    className="p-inputtext-sm rounded-4"
                    suffix={"%"}
                    onChange={sendUpdateInstallmentValue}
                    placeholder={"0.00"}
                    max={100}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    name={`interest_rate`}
                    control={control}
                    label="Taxa de Juros"
                    style={{ fontWeight: "bold" }}
                  />
                </div>

                <div className="col-md-6">
                  <NumberInput
                    required={true}
                    className="p-inputtext-sm rounded-4"
                    suffix={""}
                    prefix={""}
                    onChange={sendUpdateInstallmentValue}
                    placeholder={"0"}
                    max={300}
                    min={1}
                    name={`number_installments`}
                    control={control}
                    label="Qtde. de Parcelas do Financiamento"
                    style={{ fontWeight: "bold" }}
                  />
                </div>
              </div>

              {/* FINANCIAMENTO */}
              <div className="row">
                <div className="col-md-6">
                  <Input

                    className="p-inputtext-sm rounded-4"
                    disabled={true}
                    suffix={""}
                    prefix={"R$"}
                    placeholder={"0"}
                    max={undefined}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    name={`installments_value`}
                    control={control}
                    label="Valor da Parcela Financiamento"
                    style={{ fontWeight: "bold" }}
                  />
                </div>

                <div className="col-md-6">
                  <CalendarInput
                    isRequired={true}
                    type="textarea"
                    className="p-inputtext-sm rounded-4"
                    label="Data 1º Financiamento"
                    errors={errors}
                    control={control}
                    name="installments_date"
                    rows={4}
                    cols={30}
                  />
                </div>
              </div>

              {/* DATA DA RENEGOCIAÇÃO */}
              <div className="row">
                <div className="col-md-6">
                  <CalendarInput
                    type="textarea"
                    className="p-inputtext-sm rounded-4"
                    label="Data da Renegociação"
                    errors={errors}
                    isRequired={true}
                    control={control}
                    name="renegotiate_date"
                    rows={4}
                    cols={30}
                  />
                </div>
                <div className="col-md-6 text-center mt-3 pt-2">
                  <Button
                    rounded
                    disabled={isCalculateClicked}
                    // visible={isVisibleConfirm}
                    label="Confirmar Renegociação"
                    icon="fa-solid fa-calculator"
                    className="p-inputtext-sm m-auto"
                    onClick={handleUpdateParcel}
                  />
                </div>
              </div>
            </div>
          )}
        </form>
      </Modal>
    </>
  );
};

export default ModalRenegotiateInstallments;
